import { createContext } from 'react'

import type { StoreApi } from 'zustand'
import type { PageStoreState } from './types'

export const PageStoreContext = createContext<StoreApi<
  PageStoreState<any, any, any>
> | null>(null)
